export const MenuItems = [
  {
    title : "Home",
    url : "/",
    cName : "nav-links",
    icon : "fa fa-home",
  },
  {
    title : "About",
    url : "/about",
    cName : "nav-links",
    icon : "fa fa-user",
  },
  {
    title : "Service",
    url : "/service",
    cName : "nav-links",
    icon : "fa fa-briefcase",
  },
  {
    title : "Contact",
    url : "/contact",
    cName : "nav-links",
    icon : "fa fa-comment",
  },
  {
    title : "Sign Up",
    url : "/signup",
    cName : "nav-links-mobile",
  },
]